import styled, { css } from 'styled-components';
import { getTextType, mq, getSpace } from '../../../stylesheets/tools';

const StyledPagination = styled.nav`
  ${getTextType('tertiary')}
  ${props =>
    !props.noPadding &&
    css`
      margin: ${getSpace('xxxl')} 0;
    `}

  ul {
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;

    ${props =>
      props.align === 'center' &&
      css`
        justify-content: center;
      `}
  }

  li {
    display: inline-flex;
    align-items: center;

    a {
      cursor: pointer;
    }
  }

  .pagination__next,
  .pagination__prev {
    margin: 0 5px;
    display: none;

    ${mq('m')} {
      display: block;
      margin: 0 20px;
    }
  }

  .pagination__spacer {
    ${mq('m')} {
      margin: 0 5px;
    }
  }

  .pagination__link {
    display: block;
    border-radius: 5px;
    margin-right: 10px;

    [data-whatinput='mouse'] &,
    [data-whatinput='touch'] & {
      outline: 0;
    }

    &[aria-current='true'] {
      clip-path: polygon(10px 0, 100% 0, 100% 100%, 0 100%, 0 10px);
      background: ${props => (props.inverted ? '#fff' : '#000')};

      .pagination__link-inner {
        position: relative;

        &:after {
          content: '';
          position: absolute;
          background: ${props => (props.inverted ? '#000' : '#fff')};
          top: 2px;
          left: 2px;
          right: 2px;
          bottom: 2px;
          clip-path: polygon(8px 0, 100% 0, 100% 100%, 0 100%, 0 8px);
          border-radius: 3px;
        }
      }
    }

    span {
      display: block;
      position: relative;
      padding: 5px 10px;
      text-align: center;
      z-index: 1;
      color: ${props => (props.inverted ? '#fff' : '#000')};

      ${mq('l')} {
        padding: 10px;
        min-width: 50px;
      }
    }
  }
`;

export default StyledPagination;
